import { AxiosError } from 'axios';

import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';
import { SubscriptionWithPlan } from '@/types/subscription.type';

export const getMySubscription = async (): Promise<
  ApiResponse<SubscriptionWithPlan>
> => {
  try {
    const response = await apiManager.get('/v1/subscriptions/my-subscription');

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
